import { Colors } from "../../constants";

export const commonRightBlackModalStyles = () => ({
	root: {
		background: Colors.black,
		color: Colors.white,
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		maxWidth: { xs: '100%', md: '565px' },
		width: '100%',
		height: '100%',
		pt: '32px',
		px: '24px',
		marginLeft: 'auto',
		position: 'relative',

		'&:focus-visible': {
			outline: 'none',
		},
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		gap: '2px',
		minHeight: '48px',
		flexShrink: 0,
		position: 'relative',
	},
	headerTitle: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '24px',
		fontWeight: '700',
		lineHeight: '29px',
		color: Colors.white,
		pr: '48px',
	},
	headerSubtitle: {
		fontFamily: 'Montserrat, sans-serif',
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '21px',
		color: Colors.white_a60,
		pr: '48px',
	},
	closeButton: {
		minWidth: '48px',
		minHeight: '48px',
		position: 'absolute',
		top: '0',
		right: '0',
		border: `1px solid ${Colors.white_a40}`,
	},
	closeIcon: {
		width: '24px',
		height: '24px',
		color: Colors.white,
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		pr: '6px',
		pt: '10px',
		flexGrow: 1,

		overflowY: 'auto',
		overflowX: 'hidden',

		'&::-webkit-scrollbar': {
			width: '4px',
		},

		'&::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		},
	},
	footer: {
		py: '12px',
		display: 'flex',
		justifyContent: 'center',
	},
	footerButton: {
		minWidth: '300px',
	},
});
